import {
  ClipboardList,
  GraduationCap,
  LayoutTemplate,
} from "lucide-react";

/**
 * Report Card hub — generate, publish and print student report cards from submitted marks.
 *
 * Permission keys:
 * - REPORT_CARD_VIEW (list/view)
 * - REPORT_CARD_FULL (create/edit/generate/publish)
 *
 * Detail routes (batches/:id, cards/:id) are opened from BatchList /
 * BatchDetail — not hub links.
 *
 * Icons use Lucide components and are rendered through the shared
 * HubIcon component by HubGrid.
 */
export const hubReportCardLinks = [
  {
    sectionTitle: "Report Cards",
    sectionIcon: ClipboardList,
    links: [
      {
        label: "Batches",
        url: "/report-cards/batches",
        desc: "Generate, publish and print report card batches from submitted marks",
        module: "REPORT_CARD",
        permission: "REPORT_CARD_VIEW",
        icon: ClipboardList,
      },
      {
        label: "Grade Schemes",
        url: "/report-cards/grade-schemes",
        desc: "Define grade ranges, letter grades and pass criteria",
        module: "REPORT_CARD",
        permission: "REPORT_CARD_VIEW",
        icon: GraduationCap,
      },
      {
        label: "Templates",
        url: "/report-cards/templates",
        desc: "Report card layout templates for generation and print",
        module: "REPORT_CARD",
        permission: "REPORT_CARD_VIEW",
        icon: LayoutTemplate,
      },
    ],
  },
];

export default hubReportCardLinks;